var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group input-no-border"},[_c('money',_vm._b({staticClass:"form-control text-right",attrs:{"disabled":_vm.disabled},nativeOn:{"change":function($event){return _vm.setData.apply(null, arguments)}},model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}},'money',_vm.money,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }